const header = document.querySelector('.site-header');
const heroNav = document.getElementById('hero-nav');

if (header && heroNav) {
  const placeholder = document.createElement('div');
  placeholder.style.display = 'none';
  header.parentNode.insertBefore(placeholder, header.nextSibling);

  let isSticky = false;
  let headerHeight = header.offsetHeight;

  window.addEventListener('resize', () => {
    if (!isSticky) headerHeight = header.offsetHeight;
  });

  const observer = new IntersectionObserver(
    ([entry]) => {
      const shouldStick = !entry.isIntersecting;
      if (shouldStick === isSticky) return;

      isSticky = shouldStick;

      if (shouldStick) {
        placeholder.style.height = headerHeight + 'px';
        placeholder.style.display = 'block';
        header.classList.remove('is-leaving');
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
        header.classList.add('is-leaving');

        header.addEventListener('animationend', (e) => {
          if (e.target !== header || isSticky) return;
          header.classList.remove('is-leaving');
          placeholder.style.display = 'none';
        }, { once: true });
      }
    },
    { threshold: 0 }
  );

  observer.observe(heroNav);
}
